<template>
  <div class="container">
    <my-header :curHeader="6"></my-header>
    <main v-loading="loading">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="construct-item"
        @click="toDetail(item)">
        <div class="construct-item-title">{{ item.title }}</div>
        <div class="construct-item-time">{{ $parseTime(item.publishTime, '{y}-{m}-{d}') }}</div>
      </div>
      <div v-if="!loading" class="construct-null">没有更多数据了</div>
<!--      <pagination :total="50"></pagination>-->
    </main>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHeader from '@/components/Header'
import MyFooter from '@/components/Footer'
import Pagination from '@/components/Pagination'
import { getNoticeList } from '@/api'

export default {
  components: {
    MyHeader,
    MyFooter,
    Pagination
  },
  data() {
    return {
      list: [],
      loading: true
    }
  },
  mounted() {
    getNoticeList().then(res => {
      this.list = res.rows
      this.loading = false
    })
  },
  methods: {
    toDetail(obj) {
      this.$setCurArticle(obj)
      this.$router.push('/news-detail')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  main {
    min-height: 500px;
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    .construct-item {
      height: 70px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      cursor: pointer;
      transition: all 300ms;
      background: #fff;
      margin-bottom: 10px;
      .construct-item-title {
        width: 1000px;
        color: #484E54;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .construct-item-time {
        color: #8F98A0;
      }
    }
    .construct-item:hover {
      background: #1279EC;
      .construct-item-title,.construct-item-time {
        color: #fff;
      }
    }
    .construct-null {
      margin-top: 30px;
      text-align: center;
      color: #999;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/notice/index.vue